{
  "title": "Уведомления",
  "titleUnread": "Уведомления, непрочитанных: {{count}}",
  "intro": "Пороги бюджетов и решения по запросам на увеличение. Письма и Telegram появятся позже.",
  "empty": "Уведомлений нет",
  "emptyLead": "Здесь появятся уведомления о бюджетах ваших проектов: пороги расходов и запросы на увеличение.",
  "markAll": "Отметить все прочитанными",
  "markRead": "Прочитано",
  "all": "Все уведомления",
  "unread": "Не прочитано",
  "threshold": {
    "actual": "{{project}}: израсходовано {{percent}}\u00a0% бюджета ({{amount}} из {{budget}}), порог {{threshold}}\u00a0%.",
    "forecast": "{{project}}: прогноз месяца — {{percent}}\u00a0% бюджета ({{amount}} из {{budget}}), порог {{threshold}}\u00a0%."
  },
  "raiseRequested": "{{project}}: {{name}} просит увеличить бюджет на {{amount}} ({{kind}}).",
  "raise": {
    "approved": "{{project}}: увеличение бюджета на {{amount}} одобрено.",
    "rejected": "{{project}}: увеличение бюджета на {{amount}} отклонено."
  },
  "approvalRequested": "{{project}}: ключ «{{key}}» просит одобрить {{action}} ({{target}}).",
  "approvalDecided": {
    "executed": "{{project}}: запрос ключа «{{key}}» ({{action}}) одобрен и выполнен.",
    "failed": "{{project}}: запрос ключа «{{key}}» ({{action}}) одобрен, но не выполнен.",
    "rejected": "{{project}}: запрос ключа «{{key}}» ({{action}}) отклонён.",
    "expired": "{{project}}: запрос ключа «{{key}}» ({{action}}) истёк без решения."
  }
}
